import React from 'react'
import { Box } from '@material-ui/core'
import { RuleStepProps } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { GlobalDiscountRuleState } from './types'
import {
	NumSpinner,
	ParamRow,
	RuleParamsPanel,
} from '../../CampaignModalSkeleton/components'

export function GlobalDiscountRuleStep({
	rule,
	setRule,
	description,
}: RuleStepProps<GlobalDiscountRuleState>) {
	const isDiscountError =
		rule.discount !== null &&
		(rule.discount > 100 || rule.discount <= 0)
	const thresholdError = rule.threshold !== null && rule.threshold <= 0

	return (
		<Box>
			{description}
			<RuleParamsPanel>
				<ParamRow
					label="Réduction sur toute la carte"
					description="Pourcentage appliqué à tous les produits une fois le seuil atteint"
					error={isDiscountError}
				>
					<NumSpinner
						value={rule.discount}
						onChange={(v) => setRule((prev) => ({ ...prev, discount: v }))}
						min={1}
						max={100}
						suffix="%"
						placeholder="20"
						step="any"
					/>
				</ParamRow>
				<ParamRow
					label="Seuil de déclenchement"
					description="Montant minimum du panier pour activer la remise globale"
					error={thresholdError}
					isLast
				>
					<NumSpinner
						value={rule.threshold}
						onChange={(v) => setRule((prev) => ({ ...prev, threshold: v }))}
						min={1}
						max={999999}
						suffix="€"
						placeholder="20"
						step="any"
					/>
				</ParamRow>
			</RuleParamsPanel>
		</Box>
	)
}
